import React from 'react';


const SlotsTableComponent = ({ componentSlots }) => {
    if (!componentSlots || componentSlots.length === 0) {
        return null;
    }

    return (
        <>
            <h2>Slots</h2>
            <table>
                <thead>
                <tr>
                    <th>Slot</th>
                    <th>Description</th>
                </tr>
                </thead>
                <tbody>
                {
                    componentSlots.map((item, index) => (
                        <tr key={index}>
                            <td> {item.name ? <code className="language-text">{item.name}</code> : "any"}</td>
                            <td>{item.docs}</td>
                        </tr>
                    ))
                }
                </tbody>
            </table>
        </>
    );
};

export default SlotsTableComponent;
